<template>
  <div class="w-full h-full d-flex justify-center align-center">
    <img src="@/assets/logo.png" alt />
    <v-divider vertical inset class="mx-10"></v-divider>
    <div class="mt-n2 relative">
      <div class="text-h4 font-weight-bold">404</div>
      <div class="text-h5">{{ $t('not_found') }}</div>
      <div class="absolute bottom-0 left-0 mb-n16">
          <v-btn class="w-full text-center mt-10 text-capitalize" text color="primary" :to="{name: 'Home'}" >{{ $t('start_to') }}</v-btn>

      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>